<template>
    <img
        v-if="type === 'img'"
        :src="imgSrc"
        :alt="imgAlt"
        @load="imgLoad($event)"
        @error="imgError($event)"
        :style="{ fontSize: (errorLoad && '12px') || 'unset' }"
    />
    <div
        v-else
        :style="{
            backgroundImage: imgSrc ? 'url(' + imgSrc + ')' : null,
            backgroundSize: backSize,
            backgroundPosition: backPos,
            backgroundColor: imgSrc ? '' : bgColor
        }"
        :role="imgAlt && 'img'"
        :title="imgAlt"
        :aria-label="imgAlt"
    >
        <slot></slot>
    </div>
</template>
<script>
import util from '../../common/util';
import { mapState } from 'vuex';
const regImageSizeOriginal =
    /\/\/(cdn|image|img).chime.me\/.+\/(?:(?:w|h)\d+_)??original_/;
const regImageReplaceOriginal = /\/(?:(?:w|h)\d+_)?original_/;
const regImageGif = /\.gif$/;
const isScreenshot = !!util.getQueryField('screenshot'); //当puppeteer无头浏览器加载时，则不懒加载
export default {
    props: {
        type: {
            type: String,
            default: 'img'
        },
        src: {
            validator: function (value) {
                return (
                    typeof value === 'string' ||
                    typeof value === 'object' ||
                    !value
                );
            },
            required: true,
            default: ''
        },
        dir: {
            type: String,
            default: 'width',
            validator(value) {
                if (value) {
                    return ['width', 'height'].indexOf(value) !== -1;
                } else {
                    return true;
                }
            }
        },
        size: {
            type: Number,
            default: 0
        },
        rate: {
            type: Number,
            default: 0
        },
        alt: {
            type: String,
            default: ''
        },
        lazy: {
            type: Boolean,
            default: undefined
        },
        backPos: {
            type: String,
            default: 'center'
        },
        backSize: {
            type: String,
            default: 'cover'
        },
        errorImg: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            imgSrc: null,
            visible: false,
            errorLoad: false
        };
    },
    computed: {
        originSrc() {
            return (this.src && this.src.imgUrl) || this.src;
        },
        imgAlt() {
            return (this.src && this.src.alt) || this.alt || '';
        },
        nolazy() {
            if (isScreenshot) {
                return true;
            }
            if (this.lazy != undefined) {
                return !this.lazy;
            } else {
                return this.noImgLazy;
            }
        },
        serverRender() {
            try {
                return this.renderStatus === 1 || isScreenshot;
            } catch (error) {
                return false;
            }
        },
        ...mapState({
            renderStatus: state => state.common.renderStatus
        })
    },
    watch: {
        originSrc() {
            if (this.visible) {
                this.updateSrc();
            }
        },
        dir() {
            if (this.visible) {
                this.updateSrc();
            }
        },
        size() {
            if (this.visible) {
                this.updateSrc();
            }
        },
        lazy(value) {
            if (!value && !this.visible) {
                this.visible = true;
                this.updateSrc();
            }
        }
    },
    inject: {
        noImgLazy: { default: false }
    },
    mounted() {
        // this.$el.module = this;
        if (this.nolazy) {
            this.visible = true;
            this.updateSrc();
        } else {
            util.getObserver(this.$el, () => {
                if (!this.visible) {
                    this.visible = true;
                    this.updateSrc();
                }
            });
            // this.$on('visible', () => {
            //     if (!this.visible) {
            //         this.visible = true;
            //         this.updateSrc();
            //     }
            // });
        }
    },
    created() {
        if (this.serverRender) {
            this.updateSrc();
        }
    },
    methods: {
        transfromImgSrc(src) {
            if (!regImageGif.test(src) && regImageSizeOriginal.test(src)) {
                if (this.dir) {
                    src = src.replace(
                        regImageReplaceOriginal,
                        '/' + this.getImgSize() + 'original_'
                    );
                }
                if (!/\.webp$/i.test(src)) {
                    // 移动端强制使用webp
                    if (util.isMobileReal()) {
                        src = src.replace(/\.([^.]+)$/, '-$1') + '.webp';
                    } else {
                        if (util.isSupportWebp()) {
                            src = src.replace(/\.([^.]+)$/, '-$1') + '.webp';
                        }
                    }
                }
            }
            return src;
        },
        updateSrc() {
            let src = this.originSrc;
            src = this.transfromImgSrc(src);
            if (src !== this.imgSrc) {
                if (this.type === 'img' || this.serverRender) {
                    this.imgSrc = src;
                } else {
                    if (!this.serverRender) {
                        this.bgImgLoad(src);
                    }
                }
                this.$emit('update');
            }
        },
        getImgSize() {
            const prefix = this.dir === 'width' ? 'w' : 'h';
            let size = this.size;
            if (!size) {
                if (this.serverRender) {
                    size = 300;
                } else {
                    let ele = this.$el;
                    // 尝试取img-box里面的img-content, 这个元素的尺寸更准(有时候img会莫名其妙的尺寸不准)
                    if (
                        this.$el &&
                        this.$el.parentElement &&
                        this.$el.parentElement.classList &&
                        this.$el.parentElement.classList.contains('img-content')
                    ) {
                        ele = ele.parentElement;
                    }
                    while (ele && !(size = this.calcEleSize(ele))) {
                        ele = ele.parentElement;
                        if (!ele) return '';
                    }
                }
            }

            var rate = this.rate || util.isReallyUser ? 2 : 1;
            const stepSize = this.stepSize(
                Math.ceil(rate * Math.max(10, size))
            );
            return stepSize && `${prefix}${stepSize}_`;
        },
        stepSize(size) {
            //6个档位 [200, 600, 1200, 2000, 2800, 原图]
            if (size <= 200) {
                return 200;
            }
            if (size <= 600) {
                return 600;
            }
            // if (size <= 900) {
            //     return 900;
            // }
            if (size <= 1200) {
                return 1200;
            }
            if (size <= 2000) {
                return 2000;
            }
            if (size <= 2800) {
                return 2800;
            }
            return '';
        },
        calcEleSize(ele) {
            const offsetKey =
                this.dir === 'width' ? 'offsetWidth' : 'offsetHeight';
            const offsetSize = ele[offsetKey] < 5 ? 0 : ele[offsetKey];
            const maxKey = this.dir === 'width' ? 'maxWidth' : 'maxHeight';
            const maxSize = parseInt(util.getStyle(ele)[maxKey], 10) || 0;
            let size = offsetSize || maxSize;
            if (ele.nodeName === 'IMG') {
                size = Math.max(offsetSize, maxSize);
            }
            return size;
        },
        // formatImageSize(wh) {
        //     let rate = wh < 600 ? 50 : wh < 1000 ? 10 : 20;
        //     return rate * Math.ceil(wh / rate);
        // },
        bgImgLoad(src) {
            const img = new Image();
            img.onload = $event => {
                this.imgSrc = src;
                this.imgLoad($event);
            };
            img.onerror = e => {
                this.imgSrc = src;
                this.imgError(e);
            };
            img.src = src;
        },
        imgLoad($event) {
            if (!$event || !$event.target) {
                return;
            }
            this.$emit('load', {
                src: this.imgSrc,
                height: $event.target.naturalHeight,
                width: $event.target.naturalWidth
            });
        },
        imgError(e) {
            if (this.errorImg) {
                this.imgSrc = this.transfromImgSrc(this.errorImg);
            }
            this.$emit('update');
            this.$emit('error', e);
            this.errorLoad = true;
        }
    }
};
</script>
<style lang="scss"></style>
